import { Observable, from } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestResourceModule } from 'angular/resources/rest-resource.module';
import { config } from 'angular/utils/config';
import { HttpInterceptor } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { HttpEvent } from '@angular/common/http';
import { getCognitoToken } from 'angular/utils/cognito';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return from(this.handleAccess(request, next));
    }

    private async handleAccess(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Promise<HttpEvent<any>> {
        const isMonolithRequest = request.url.startsWith(config.monolithApi);
        if (!isMonolithRequest) return next.handle(request.clone()).toPromise();

        let headers = request.headers;

        if (localStorage.getItem('ENFORCE_SHIPPER_ROLE') === 'true')
            headers = headers.set('X-Prisma-Switch-User', 'true');

        const token = await getCognitoToken();
        if (token && !headers.get('Authorization'))
            headers = headers.set('Authorization', `Bearer ${token}`);

        return next.handle(request.clone({ headers })).toPromise();
    }
}

export type QueryParams = { [param: string]: string | string[] };

@Injectable({
    providedIn: RestResourceModule
})
export class RequestService {
    private readonly restUrl = config.monolithApi + '/';

    constructor(private httpClient: HttpClient) {}

    public get<T>(relativePath: string, params?: QueryParams): Observable<T> {
        return this.httpClient.get<T>(this.restUrl + relativePath, {
            params
        });
    }

    public post<T>(relativePath: string, body: T): Observable<T> {
        let options = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.httpClient.post<T>(
            this.restUrl + relativePath,
            body,
            options
        );
    }

    public put<T>(relativePath: string, body: T): Observable<T> {
        return this.httpClient.put<T>(this.restUrl + relativePath, body);
    }

    public delete<T>(relativePath: string): Observable<T> {
        return this.httpClient.delete<T>(this.restUrl + relativePath);
    }

    public postFormData<T>(
        relativePath: string,
        formData: FormData
    ): Observable<T> {
        return this.httpClient.post<T>(this.restUrl + relativePath, formData);
    }
}
